
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class SetDomainEmailsRequestModel extends Model<SetDomainEmailsRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'domainName', type: 'string' },
		{ name: 'primaryEmail', type: 'string' },
		{ name: 'secondaryEmail', type: 'string' }
	];
	[key: string]: any;
	
	public domainName: string;
	public primaryEmail: string;
	public secondaryEmail: string;
    
	constructor(){
		super();
		this.domainName = '';
		this.primaryEmail = '';
		this.secondaryEmail = '';
		
	}
	getProperties(){
		return SetDomainEmailsRequestModel.classProperties;
	}
}

